import { useIsAdmin } from "../../customHooks/roleChecker/useIsAdmin";
import { useIsManager } from "../../customHooks/roleChecker/useIsManager";
import { useIsSuperAdmin } from "../../customHooks/roleChecker/useIsSuperAdmin";
import { Link, useNavigate } from "react-router-dom";
import { PageHeading } from "../common/pageHeading/PageHeading";
import { Loader } from "../common/loader/Loader";
import styles from "./salesReport.module.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { faSackDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetSalesSummaryQuery } from "../../features/api/dashBoard/dashBoardApi";
import { useGetCurrentCapitalQuery } from "../../features/api/currentCapital/currentCapitalApi";
import dateFormatter from "../../utils/dateFormatter";
export const SalesReport = () => {
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isSuperAdmin = useIsSuperAdmin();
  const navigate = useNavigate();
  const { data: salesData, isLoading, isError } = useGetSalesSummaryQuery();
  const {
    data: capitalData,
    isLoading: isCapitalDataLoading,
    isError: isCapitalDataError,
  } = useGetCurrentCapitalQuery({
    skip: !isAdmin || !isSuperAdmin || isManager,
  });

  //Decide what to render -

  let content = null;

  let currentCapitalcontent = null;

  if (isLoading) {
    content = (
      <div className="mb-5">
        <PageHeading title={"Sales Report"} />
        <Loader />
      </div>
    );
  }

  if (isCapitalDataLoading) {
    currentCapitalcontent = (
      <div className="mb-5">
        <PageHeading title={"Current Capital"} />
        <Loader />
      </div>
    );
  }
  if (capitalData) {
    currentCapitalcontent = (
      <div>
        <h2 className={`${styles.salesReportHeading} shadow-sm`}>
          Current Capital
        </h2>
        <hr />
        <Row>
          <Col lg={4} md={4} xs={12} className="mt-1">
            <Card border="info" text={"white"} className={styles.bgPink}>
              <Card.Header className={styles.cardHeader}>
                <FontAwesomeIcon
                  icon={faFileInvoiceDollar}
                  className={`${styles.amountIcon} ${styles.iconBankTotal}`}
                />
                <span>Bank</span>
              </Card.Header>
              <Card.Body>
                <Card.Subtitle className="mb-1 text-white">
                  {capitalData.bankBalance.toLocaleString("de-DE")} €
                </Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={4} md={4} xs={12} className="mt-1">
            <Link to={"/reporting"} className={styles.breakDownLink}>
              <Card border="info" text={"white"} className={styles.bgPurple}>
                <Card.Header className={styles.cardHeader}>
                  <FontAwesomeIcon
                    icon={faDollarSign}
                    className={`${styles.amountIcon} ${styles.iconGrandTotal}`}
                  />
                  <span>
                    Grand Total | {dateFormatter(capitalData.updatedAt)}
                  </span>
                </Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {(
                      capitalData.bankBalance + capitalData.cashBalance
                    ).toLocaleString("de-DE")}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col lg={4} md={4} xs={12} className="mt-1">
            <Card border="info" text={"white"} className={styles.bgPink}>
              <Card.Header className={styles.cardHeader}>
                <FontAwesomeIcon
                  icon={faMoneyCheckDollar}
                  className={`${styles.amountIcon} ${styles.iconBankTotal}`}
                />
                <span>Cash</span>
              </Card.Header>
              <Card.Body>
                <Card.Subtitle className="mb-1 text-white">
                  {capitalData.cashBalance.toLocaleString("de-DE")} €
                </Card.Subtitle>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  if (salesData) {
    content = (
      <div className="mb-5">
        <Container className={`${styles.reportContainer} my-5`}>
          <h2 className={`${styles.salesReportHeading} shadow-sm`}>
            Sales Report
          </h2>
          <hr />
          <Row>
            <Col lg={4} md={4} xs={12} className="mt-1">
              <Card border="info" text={"white"} className={styles.bgRed}>
                <Card.Header className={styles.cardHeader}>
                  <FontAwesomeIcon
                    icon={faFileInvoiceDollar}
                    className={`${styles.amountIcon} ${styles.iconLeftTotal}`}
                  />
                  <span>Pending</span>
                </Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {(
                      salesData?.grandTotalAmount -
                      (salesData?.totalDeliveredCollectedAmount +
                        salesData?.totalInvoicedCollectedAmount)
                    ).toLocaleString("de-DE")}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={4} xs={12} className="mt-1">
              <Link to={"/reporting"} className={styles.breakDownLink}>
                <Card border="info" text={"white"} className={styles.bgPurple}>
                  <Card.Header className={styles.cardHeader}>
                    <FontAwesomeIcon
                      icon={faDollarSign}
                      className={`${styles.amountIcon} ${styles.iconGrandTotal}`}
                    />
                    <span>Grand Total</span>
                  </Card.Header>
                  <Card.Body>
                    <Card.Subtitle className="mb-1 text-white">
                      {salesData?.grandTotalAmount.toLocaleString("de-DE")} €
                    </Card.Subtitle>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
            <Col lg={4} md={4} xs={12} className="mt-1">
              <Card border="info" text={"white"} className={styles.bgGreen}>
                <Card.Header className={styles.cardHeader}>
                  <FontAwesomeIcon
                    icon={faMoneyCheckDollar}
                    className={`${styles.amountIcon} ${styles.iconCompleteTotal}`}
                  />
                  <span>Complete</span>
                </Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {(
                      salesData?.totalDeliveredCollectedAmount +
                      salesData?.totalInvoicedCollectedAmount
                    ).toLocaleString("de-DE")}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={2} md={4} xs={6} className="mt-2">
              <Card border="info" text={"white"} className={styles.bgPink}>
                <Card.Header className={styles.cardHeader}>
                  <FontAwesomeIcon
                    icon={faCreditCard}
                    className={`${styles.amountIcon} ${styles.iconBankTotal}`}
                  />
                  <span>Banking Total</span>
                </Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {salesData?.totalInvoicedAmount.toLocaleString("de-DE")} €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={2} md={4} xs={6} className="mt-2">
              <Card
                border="info"
                text={"white"}
                className={styles.bgPurpleLight}
              >
                <Card.Header>Banking Complete</Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {salesData?.totalInvoicedCollectedAmount.toLocaleString(
                      "de-DE"
                    )}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={2} md={4} xs={6} className="mt-2">
              <Card border="info" text={"white"} className={styles.bgRed}>
                <Card.Header>Banking Pending</Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {(
                      salesData?.totalInvoicedAmount -
                      salesData?.totalInvoicedCollectedAmount
                    ).toLocaleString("de-DE")}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={2} md={4} xs={6} className="mt-2">
              <Card border="info" text={"white"} className={styles.bgPinkLight}>
                <Card.Header className={styles.cardHeader}>
                  <FontAwesomeIcon
                    icon={faSackDollar}
                    className={`${styles.amountIcon} ${styles.iconCashTotal}`}
                  />
                  <span>Cash Total</span>
                </Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {salesData?.totalDeliveredAmount.toLocaleString("de-DE")} €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={2} md={4} xs={6} className="mt-2">
              <Card
                border="info"
                text={"white"}
                className={styles.bgPurpleLight}
              >
                <Card.Header>Cash Complete</Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {salesData?.totalDeliveredCollectedAmount.toLocaleString(
                      "de-DE"
                    )}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={2} md={4} xs={6} className="mt-2">
              <Card border="info" text={"white"} className={styles.bgRed}>
                <Card.Header>Cash Pending</Card.Header>
                <Card.Body>
                  <Card.Subtitle className="mb-1 text-white">
                    {(
                      salesData?.totalDeliveredAmount -
                      salesData?.totalDeliveredCollectedAmount
                    ).toLocaleString("de-DE")}{" "}
                    €
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <hr />
          {(isAdmin || isSuperAdmin || isManager) && currentCapitalcontent}
        </Container>
      </div>
    );
  }
  return content;
};
